
// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";

// const CTCForm = () => {
//   const [earnings, setEarnings] = useState([]);
//   const [deductions, setDeductions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("earnings");

//   // Fetch CTC data on component mount
//   useEffect(() => {
//     fetchCTCData();
//   }, []);

//   const fetchCTCData = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`);
//       const result = await response.json();

//       if (response.ok) {
//         setEarnings(result.earnings || []);
//         setDeductions(result.deductions || []);
//       } else {
//         alert(result.error);
//       }
//     } catch (error) {
//       console.error("Error fetching CTC data:", error);
//     }
//     setLoading(false);
//   };

//   // Add new field to earnings or deductions
//   const addField = (setState, type) => {
//     const newField = prompt(`Enter new ${type}:`);
//     if (newField) {
//       setState((prev) => [...prev, newField]);
//     }
//   };

//   // Remove field from earnings or deductions
//   const removeField = (setState, index) => {
//     setState((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Submit updated CTC structure
//   const updateCTC = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/update_ctc`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ earnings, deductions }),
//       });

//       const result = await response.json();
//       if (response.ok) {
//         alert("CTC structure updated successfully!");
//       } else {
//         alert(result.error);
//       }
//     } catch (error) {
//       console.error("Error updating CTC structure:", error);
//       alert("Failed to update CTC structure.");
//     }
//     setLoading(false);
//   };

//   return (
//     <div className="ctc-form-container">
//       <motion.div 
//         initial={{ opacity: 0, y: 20 }}
//         animate={{ opacity: 1, y: 0 }}
//         transition={{ duration: 0.5 }}
//         className="ctc-form-card"
//       >
//         <h2 className="form-title">CTC Structure Configuration</h2>
//         <p className="form-subtitle">Manage earnings and deductions components</p>

//         <div className="tabs-container">
//           <button
//             className={`tab-button ${activeTab === "earnings" ? "active" : ""}`}
//             onClick={() => setActiveTab("earnings")}
//           >
//             Earnings
//           </button>
//           <button
//             className={`tab-button ${activeTab === "deductions" ? "active" : ""}`}
//             onClick={() => setActiveTab("deductions")}
//           >
//             Deductions
//           </button>
//         </div>

//         <div className="tab-content">
//           {activeTab === "earnings" ? (
//             <>
//               <div className="section-header">
//                 <h3>Earnings Components</h3>
//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="add-button"
//                   onClick={() => addField(setEarnings, "earning")}
//                 >
//                   <span>+</span> Add Earning
//                 </motion.button>
//               </div>
              
//               <AnimatePresence>
//                 {earnings.length === 0 ? (
//                   <motion.p 
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     className="empty-state"
//                   >
//                     No earnings components added yet.
//                   </motion.p>
//                 ) : (
//                   <ul className="items-list">
//                     <AnimatePresence>
//                       {earnings.map((field, index) => (
//                         <motion.li
//                           key={index}
//                           initial={{ opacity: 0, x: -20 }}
//                           animate={{ opacity: 1, x: 0 }}
//                           exit={{ opacity: 0, x: 20 }}
//                           transition={{ duration: 0.2 }}
//                           className="list-item"
//                         >
//                           <span className="item-text">{field}</span>
//                           <motion.button
//                             whileHover={{ scale: 1.1 }}
//                             whileTap={{ scale: 0.9 }}
//                             className="remove-button"
//                             onClick={() => removeField(setEarnings, index)}
//                             aria-label={`Remove ${field}`}
//                           >
//                             ×
//                           </motion.button>
//                         </motion.li>
//                       ))}
//                     </AnimatePresence>
//                   </ul>
//                 )}
//               </AnimatePresence>
//             </>
//           ) : (
//             <>
//               <div className="section-header">
//                 <h3>Deductions Components</h3>
//                 <motion.button
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.95 }}
//                   className="add-button"
//                   onClick={() => addField(setDeductions, "deduction")}
//                 >
//                   <span>+</span> Add Deduction
//                 </motion.button>
//               </div>
              
//               <AnimatePresence>
//                 {deductions.length === 0 ? (
//                   <motion.p 
//                     initial={{ opacity: 0 }}
//                     animate={{ opacity: 1 }}
//                     className="empty-state"
//                   >
//                     No deductions components added yet.
//                   </motion.p>
//                 ) : (
//                   <ul className="items-list">
//                     <AnimatePresence>
//                       {deductions.map((field, index) => (
//                         <motion.li
//                           key={index}
//                           initial={{ opacity: 0, x: -20 }}
//                           animate={{ opacity: 1, x: 0 }}
//                           exit={{ opacity: 0, x: 20 }}
//                           transition={{ duration: 0.2 }}
//                           className="list-item"
//                         >
//                           <span className="item-text">{field}</span>
//                           <motion.button
//                             whileHover={{ scale: 1.1 }}
//                             whileTap={{ scale: 0.9 }}
//                             className="remove-button"
//                             onClick={() => removeField(setDeductions, index)}
//                             aria-label={`Remove ${field}`}
//                           >
//                             ×
//                           </motion.button>
//                         </motion.li>
//                       ))}
//                     </AnimatePresence>
//                   </ul>
//                 )}
//               </AnimatePresence>
//             </>
//           )}
//         </div>

//         <motion.button
//           whileHover={{ scale: 1.02 }}
//           whileTap={{ scale: 0.98 }}
//           onClick={updateCTC}
//           disabled={loading}
//           className="submit-button"
//         >
//           {loading ? (
//             <>
//               <span className="spinner"></span>
//               Updating...
//             </>
//           ) : (
//             "Save CTC Structure"
//           )}
//         </motion.button>
//       </motion.div>

//       <style jsx>{`
//         .ctc-form-container {
//           display: flex;
//           justify-content: center;
//           align-items: center;
//           min-height: 100vh;
//           background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
//           padding: 20px;
//         }
        
//         .ctc-form-card {
//           background: white;
//           border-radius: 16px;
//           box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
//           padding: 32px;
//           width: 100%;
//           max-width: 600px;
//         }
        
//         .form-title {
//           color: #2c3e50;
//           margin: 0 0 8px 0;
//           font-size: 24px;
//           font-weight: 600;
//           text-align: center;
//         }
        
//         .form-subtitle {
//           color: #7f8c8d;
//           margin: 0 0 24px 0;
//           font-size: 14px;
//           text-align: center;
//         }
        
//         .tabs-container {
//           display: flex;
//           border-bottom: 1px solid #e0e0e0;
//           margin-bottom: 24px;
//         }
        
//         .tab-button {
//           padding: 12px 24px;
//           background: none;
//           border: none;
//           cursor: pointer;
//           font-weight: 500;
//           color: #7f8c8d;
//           position: relative;
//           transition: all 0.3s ease;
//         }
        
//         .tab-button.active {
//           color: #3498db;
//         }
        
//         .tab-button.active::after {
//           content: '';
//           position: absolute;
//           bottom: -1px;
//           left: 0;
//           right: 0;
//           height: 3px;
//           background: #3498db;
//           border-radius: 3px 3px 0 0;
//         }
        
//         .section-header {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           margin-bottom: 16px;
//         }
        
//         .section-header h3 {
//           margin: 0;
//           color: #2c3e50;
//           font-size: 18px;
//         }
        
//         .add-button {
//           background: #2ecc71;
//           color: white;
//           border: none;
//           padding: 8px 16px;
//           border-radius: 8px;
//           font-size: 14px;
//           cursor: pointer;
//           display: flex;
//           align-items: center;
//           gap: 6px;
//         }
        
//         .add-button span {
//           font-size: 18px;
//         }
        
//         .items-list {
//           list-style: none;
//           padding: 0;
//           margin: 0;
//           display: flex;
//           flex-direction: column;
//           gap: 8px;
//         }
        
//         .list-item {
//           display: flex;
//           justify-content: space-between;
//           align-items: center;
//           padding: 12px 16px;
//           background: #f8f9fa;
//           border-radius: 8px;
//           border: 1px solid #e9ecef;
//         }
        
//         .item-text {
//           flex: 1;
//           color: #2c3e50;
//         }
        
//         .remove-button {
//           background: #e74c3c;
//           color: white;
//           border: none;
//           width: 24px;
//           height: 24px;
//           border-radius: 50%;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           cursor: pointer;
//           font-size: 16px;
//           padding: 0;
//         }
        
//         .empty-state {
//           color: #95a5a6;
//           text-align: center;
//           padding: 24px;
//           background: #f8f9fa;
//           border-radius: 8px;
//           border: 1px dashed #e9ecef;
//         }
        
//         .submit-button {
//           width: 100%;
//           padding: 14px;
//           background: #3498db;
//           color: white;
//           border: none;
//           border-radius: 8px;
//           font-weight: 500;
//           font-size: 16px;
//           cursor: pointer;
//           margin-top: 24px;
//           display: flex;
//           align-items: center;
//           justify-content: center;
//           gap: 8px;
//         }
        
//         .submit-button:disabled {
//           background: #bdc3c7;
//           cursor: not-allowed;
//         }
        
//         .spinner {
//           width: 18px;
//           height: 18px;
//           border: 3px solid rgba(255, 255, 255, 0.3);
//           border-radius: 50%;
//           border-top-color: white;
//           animation: spin 1s ease-in-out infinite;
//         }
        
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </div>
//   );
// };

// export default CTCForm;

// import React, { useState, useEffect } from "react";
// import { motion, AnimatePresence } from "framer-motion";
// import { useTheme, Box, Typography, Button } from "@mui/material";
// import { tokens } from "../../theme";
// import Header from '../../components/Header';

// const CTCForm = () => {
//   const theme = useTheme();
//   const colors = tokens(theme.palette.mode);
//   const [earnings, setEarnings] = useState([]);
//   const [deductions, setDeductions] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [activeTab, setActiveTab] = useState("earnings");

//   // Fetch CTC data on component mount
//   useEffect(() => {
//     fetchCTCData();
//   }, []);

//   const fetchCTCData = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`);
//       const result = await response.json();

//       if (response.ok) {
//         setEarnings(result.earnings || []);
//         setDeductions(result.deductions || []);
//       } else {
//         alert(result.error);
//       }
//     } catch (error) {
//       console.error("Error fetching CTC data:", error);
//     }
//     setLoading(false);
//   };

//   // Add new field to earnings or deductions
//   const addField = (setState, type) => {
//     const newField = prompt(`Enter new ${type}:`);
//     if (newField) {
//       setState((prev) => [...prev, newField]);
//     }
//   };

//   // Remove field from earnings or deductions
//   const removeField = (setState, index) => {
//     setState((prev) => prev.filter((_, i) => i !== index));
//   };

//   // Submit updated CTC structure
//   const updateCTC = async () => {
//     setLoading(true);
//     try {
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/update_ctc`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ earnings, deductions }),
//       });

//       const result = await response.json();
//       if (response.ok) {
//         alert("CTC structure updated successfully!");
//       } else {
//         alert(result.error);
//       }
//     } catch (error) {
//       console.error("Error updating CTC structure:", error);
//       alert("Failed to update CTC structure.");
//     }
//     setLoading(false);
//   };

//   return (
//     <Box 
//       m="20px"
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center"
//       }}
//     >
//       <Header title="CTC STRUCTURE" subtitle="Configure earnings and deductions" />
      
//       <Box 
//         sx={{
//           width: "100%",
//           maxWidth: "800px",
//           p: { xs: 2, sm: 3 },
//         }}
//       >
//         <motion.div 
//           initial={{ opacity: 0, y: 20 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.5 }}
//           style={{
//             backgroundColor: colors.primary[400],
//             borderRadius: "8px",
//             padding: "24px",
//             width: "100%"
//           }}
//         >
//           <Box sx={{ 
//             display: "flex",
//             borderBottom: `1px solid ${colors.primary[500]}`,
//             mb: 3,
//             gap: 1
//           }}>
//             <Button
//               sx={{
//                 flex: 1,
//                 py: 1,
//                 background: activeTab === "earnings" ? colors.blueAccent[500] : "transparent",
//                 color: activeTab === "earnings" ? colors.grey[100] : '',
//                 borderRadius: "4px 4px 0 0",
//                 fontWeight: 500,
//                 "&:hover": {
//                   backgroundColor: activeTab == "earnings" ? colors.grey[600] :colors.grey[600]
//                 }
//               }}
//               onClick={() => setActiveTab("earnings")}
//             >
//               Earnings
//             </Button>
//             <Button
//               sx={{
//                 flex: 1,
//                 py: 1,
//                 background: activeTab === "deductions" ? colors.blueAccent[500] : "transparent",
//                 color: activeTab === "deductions" ? colors.grey[100] : colors.grey[300],
//                 borderRadius: "4px 4px 0 0",
//                 fontWeight: 500,
//                 "&:hover": {
//                   backgroundColor: activeTab === "deductions" ? colors.blueAccent[600] : colors.primary[500]
//                 }
//               }}
//               onClick={() => setActiveTab("deductions")}
//             >
//               Deductions
//             </Button>
//           </Box>

//           <Box sx={{ minHeight: "300px" }}>
//             {activeTab === "earnings" ? (
//               <>
//                 <Box sx={{ 
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2
//                 }}>
//                   <Typography variant="h5" sx={{ 
//                     color: colors.grey[100],
//                     fontWeight: 600
//                   }}>
//                     Earnings Components
//                   </Typography>
//                   <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     style={{
//                       background: colors.greenAccent[500],
//                       color: colors.grey[100],
//                       border: "none",
//                       padding: "8px 16px",
//                       borderRadius: "6px",
//                       fontSize: "14px",
//                       cursor: "pointer",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "6px",
//                       fontWeight: 500
//                     }}
//                     onClick={() => addField(setEarnings, "earning")}
//                   >
//                     <span>+</span> Add Earning
//                   </motion.button>
//                 </Box>
                
//                 <AnimatePresence>
//                   {earnings.length === 0 ? (
//                     <motion.p 
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       style={{
//                         color: colors.grey[300],
//                         textAlign: "center",
//                         padding: "40px 24px",
//                         background: theme.palette.mode === "dark" ? colors.grey[500] : colors.grey[100],
//                         borderRadius: "8px",
//                         border: `1px dashed ${colors.primary[600]}`,
//                         margin: 0
//                       }}
//                     >
//                       No earnings components added yet.
//                     </motion.p>
//                   ) : (
//                     <Box sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px"
//                     }}>
//                       <AnimatePresence>
//                         {earnings.map((field, index) => (
//                           <motion.div
//                             key={index}
//                             initial={{ opacity: 0, x: -20 }}
//                             animate={{ opacity: 1, x: 0 }}
//                             exit={{ opacity: 0, x: 20 }}
//                             transition={{ duration: 0.2 }}
//                             style={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               padding: "12px 16px",
//                               background: theme.palette.mode === "dark" ? colors.primary[500] :'',
//                               color:theme.palette.mode === "dark" ?  '' :colors.primary[500],
//                               borderRadius: "6px",
//                               border: `1px solid ${colors.primary[600]}`
//                             }}
//                           >
//                             <span style={{ 
//                               flex: 1,
//                               color: theme.palette.mode === "dark" ? colors.grey[100] : colors.primary[500],
//                               fontWeight: 500
//                             }}>
//                               {field}
//                             </span>
//                             <motion.button
//                               whileHover={{ scale: 1.1 }}
//                               whileTap={{ scale: 0.9 }}
//                               style={{
//                                 background: colors.redAccent[500],
//                                 color: colors.grey[100],
//                                 border: "none",
//                                 width: "28px",
//                                 height: "28px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 cursor: "pointer",
//                                 fontSize: "16px",
//                                 padding: 0
//                               }}
//                               onClick={() => removeField(setEarnings, index)}
//                               aria-label={`Remove ${field}`}
//                             >
//                               ×
//                             </motion.button>
//                           </motion.div>
//                         ))}
//                       </AnimatePresence>
//                     </Box>
//                   )}
//                 </AnimatePresence>
//               </>
//             ) : (
//               <>
//                 <Box sx={{ 
//                   display: "flex",
//                   justifyContent: "space-between",
//                   alignItems: "center",
//                   mb: 2
//                 }}>
//                   <Typography variant="h5" sx={{ 
//                     color: colors.grey[100],
//                     fontWeight: 600
//                   }}>
//                     Deductions Components
//                   </Typography>
//                   <motion.button
//                     whileHover={{ scale: 1.05 }}
//                     whileTap={{ scale: 0.95 }}
//                     style={{
//                       background: colors.greenAccent[500],
//                       color: colors.grey[100],
//                       border: "none",
//                       padding: "8px 16px",
//                       borderRadius: "6px",
//                       fontSize: "14px",
//                       cursor: "pointer",
//                       display: "flex",
//                       alignItems: "center",
//                       gap: "6px",
//                       fontWeight: 500
//                     }}
//                     onClick={() => addField(setDeductions, "deduction")}
//                   >
//                     <span>+</span> Add Deduction
//                   </motion.button>
//                 </Box>
                
//                 <AnimatePresence>
//                   {deductions.length === 0 ? (
//                     <motion.p 
//                       initial={{ opacity: 0 }}
//                       animate={{ opacity: 1 }}
//                       style={{
//                         color: colors.grey[300],
//                         textAlign: "center",
//                         padding: "40px 24px",
//                         background: theme.palette.mode === "dark" ? colors.grey[500] : '',
//                         borderRadius: "8px",
//                         border: `1px dashed ${colors.primary[600]}`,
//                         margin: 0
//                       }}
//                     >
//                       No deductions components added yet.
//                     </motion.p>
//                   ) : (
//                     <Box sx={{
//                       display: "flex",
//                       flexDirection: "column",
//                       gap: "8px"
//                     }}>
//                       <AnimatePresence>
//                         {deductions.map((field, index) => (
//                           <motion.div
//                             key={index}
//                             initial={{ opacity: 0, x: -20 }}
//                             animate={{ opacity: 1, x: 0 }}
//                             exit={{ opacity: 0, x: 20 }}
//                             transition={{ duration: 0.2 }}
//                             style={{
//                               display: "flex",
//                               justifyContent: "space-between",
//                               alignItems: "center",
//                               padding: "12px 16px",
//                               background: theme.palette.mode === "dark" ? colors.primary[500] : '',
//                               borderRadius: "6px",
//                               border: `1px solid ${colors.primary[600]}`
//                             }}
//                           >
//                             <span style={{ 
//                               flex: 1,
//                               color: theme.palette.mode === "dark" ? '' : colors.primary[500],
//                               fontWeight: 500
//                             }}>
//                               {field}
//                             </span>
//                             <motion.button
//                               whileHover={{ scale: 1.1 }}
//                               whileTap={{ scale: 0.9 }}
//                               style={{
//                                 background: colors.redAccent[500],
//                                 color: colors.grey[100],
//                                 border: "none",
//                                 width: "28px",
//                                 height: "28px",
//                                 borderRadius: "50%",
//                                 display: "flex",
//                                 alignItems: "center",
//                                 justifyContent: "center",
//                                 cursor: "pointer",
//                                 fontSize: "16px",
//                                 padding: 0
//                               }}
//                               onClick={() => removeField(setDeductions, index)}
//                               aria-label={`Remove ${field}`}
//                             >
//                               ×
//                             </motion.button>
//                           </motion.div>
//                         ))}
//                       </AnimatePresence>
//                     </Box>
//                   )}
//                 </AnimatePresence>
//               </>
//             )}
//           </Box>

//           <motion.button
//             whileHover={{ scale: 1.02 }}
//             whileTap={{ scale: 0.98 }}
//             onClick={updateCTC}
//             disabled={loading}
//             style={{
//               width: "100%",
//               padding: "12px",
//               background: colors.blueAccent[500],
//               color: colors.grey[100],
//               border: "none",
//               borderRadius: "6px",
//               fontWeight: 500,
//               fontSize: "16px",
//               cursor: "pointer",
//               marginTop: "24px",
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "center",
//               gap: "8px",
//               opacity: loading ? 0.7 : 1
//             }}
//           >
//             {loading ? (
//               <>
//                 <span style={{
//                   width: "18px",
//                   height: "18px",
//                   border: `3px solid ${colors.grey[100]}`,
//                   borderRadius: "50%",
//                   borderTopColor: "transparent",
//                   animation: "spin 1s linear infinite"
//                 }}></span>
//                 Updating...
//               </>
//             ) : (
//               "Save CTC Structure"
//             )}
//           </motion.button>
//         </motion.div>
//       </Box>

//       <style jsx global>{`
//         @keyframes spin {
//           to { transform: rotate(360deg); }
//         }
//       `}</style>
//     </Box>
//   );
// };

// export default CTCForm;



import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { useTheme, Box, Typography, Button } from "@mui/material";
import { tokens } from "../../theme";
import Header from '../../components/Header';

const CTCForm = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [earnings, setEarnings] = useState([]);
  const [deductions, setDeductions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("earnings");
  const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
  // Fetch CTC data on component mount
  useEffect(() => {
    fetchCTCData();
  }, []);

  const fetchCTCData = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/get_ctc`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accessToken}`
        }
      });
      const result = await response.json();

      if (response.ok) {
        setEarnings(result.earnings || []);
        setDeductions(result.deductions || []);
      } else {
        alert(result.error);
      }
    } catch (error) {
      console.error("Error fetching CTC data:", error);
    }
    setLoading(false);
  };

  // Add new field to earnings or deductions
  const addField = (setState, type) => {
    const newField = prompt(`Enter new ${type}:`);
    if (newField) {
      setState((prev) => [...prev, newField]);
    }
  };

  // Remove field from earnings or deductions
  const removeField = (setState, index) => {
    setState((prev) => prev.filter((_, i) => i !== index));
  };

  // Submit updated CTC structure
  const updateCTC = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/update_ctc`, {
        method: "POST",
        headers: { "Content-Type": "application/json",'Authorization': `Bearer ${accessToken}` },
        body: JSON.stringify({ earnings, deductions }),
      });

      const result = await response.json();
      if (response.ok) {
        alert("CTC structure updated successfully!");
      } else {
        alert(result.error);
      }
    } catch (error) {
      console.error("Error updating CTC structure:", error);
      alert("Failed to update CTC structure.");
    }
    setLoading(false);
  };

  return (
    <Box 
      m="20px"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center"
      }}
    >
      <Header title="CTC STRUCTURE" subtitle="Configure earnings and deductions" />
      
      <Box 
        sx={{
          width: "100%",
          maxWidth: "800px",
          p: { xs: 2, sm: 3 },
        }}
      >
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          style={{
            backgroundColor: colors.primary[400],
            borderRadius: "8px",
            padding: "24px",
            width: "100%"
          }}
        >
          <Box sx={{ 
            display: "flex",
            borderBottom: `1px solid ${colors.primary[500]}`,
            mb: 3,
            gap: 1
          }}>
            <Button
              sx={{
                flex: 1,
                py: 1,
                background: activeTab === "earnings" ? colors.blueAccent[500] : "transparent",
                color: activeTab === "earnings" ? colors.grey[100] : colors.grey[300],
                borderRadius: "4px 4px 0 0",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: colors.grey[600]
                }
              }}
              onClick={() => setActiveTab("earnings")}
            >
              Earnings
            </Button>
            <Button
              sx={{
                flex: 1,
                py: 1,
                background: activeTab === "deductions" ? colors.blueAccent[500] : "transparent",
                color: activeTab === "deductions" ? colors.grey[100] : colors.grey[300],
                borderRadius: "4px 4px 0 0",
                fontWeight: 500,
                "&:hover": {
                  backgroundColor: colors.grey[600]
                }
              }}
              onClick={() => setActiveTab("deductions")}
            >
              Deductions
            </Button>
          </Box>

          <Box sx={{ minHeight: "300px" }}>
            {activeTab === "earnings" ? (
              <>
                <Box sx={{ 
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2
                }}>
                  <Typography variant="h5" sx={{ 
                    color: colors.grey[100],
                    fontWeight: 600
                  }}>
                    Earnings Components
                  </Typography>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      background: colors.greenAccent[500],
                      color: colors.grey[100],
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontWeight: 500
                    }}
                    onClick={() => addField(setEarnings, "earning")}
                  >
                    <span>+</span> Add Earning
                  </motion.button>
                </Box>
                
                <AnimatePresence>
                  {earnings.length === 0 ? (
                    <motion.p 
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      style={{
                        color: colors.grey[300],
                        textAlign: "center",
                        padding: "40px 24px",
                        background: colors.primary[500],
                        borderRadius: "8px",
                        border: `1px dashed ${colors.primary[600]}`,
                        margin: 0
                      }}
                    >
                      No earnings components added yet.
                    </motion.p>
                  ) : (
                    <Box sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px"
                    }}>
                      <AnimatePresence>
                        {earnings.map((field, index) => (
                          <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.2 }}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "12px 16px",
                              background: theme.palette.mode === "dark" ? colors.primary[500] : '',
                              color: colors.grey[100],
                              borderRadius: "6px",
                              border: `1px solid ${colors.primary[600]}`,
                              cursor: "pointer"
                            }}
                            whileHover={{ 
                              backgroundColor: colors.grey[600]
                            }}
                          >
                            <span style={{ 
                              flex: 1,
                              color: colors.grey[100],
                              fontWeight: 500
                            }}>
                              {field}
                            </span>
                            <motion.button
                              whileHover={{ scale: 1.1 }}
                              whileTap={{ scale: 0.9 }}
                              style={{
                                background: colors.redAccent[500],
                                color: colors.grey[100],
                                border: "none",
                                width: "28px",
                                height: "28px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: 0
                              }}
                              onClick={() => removeField(setEarnings, index)}
                              aria-label={`Remove ${field}`}
                            >
                              ×
                            </motion.button>
                          </motion.div>
                        ))}
                      </AnimatePresence>
                    </Box>
                  )}
                </AnimatePresence>
              </>
            ) : (
              <>
                <Box sx={{ 
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 2
                }}>
                  <Typography variant="h5" sx={{ 
                    color: colors.grey[100],
                    fontWeight: 600
                  }}>
                    Deductions Components
                  </Typography>
                  <motion.button
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                    style={{
                      background: colors.greenAccent[500],
                      color: colors.grey[100],
                      border: "none",
                      padding: "8px 16px",
                      borderRadius: "6px",
                      fontSize: "14px",
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      fontWeight: 500
                    }}
                    onClick={() => addField(setDeductions, "deduction")}
                  >
                    <span>+</span> Add Deduction
                  </motion.button>
                </Box>
                
                <AnimatePresence>
                  {deductions.length === 0 ? (
                    <motion.p 
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      style={{
                        color: colors.grey[300],
                        textAlign: "center",
                        padding: "40px 24px",
                        background: colors.primary[500],
                        borderRadius: "8px",
                        border: `1px dashed ${colors.primary[600]}`,
                        margin: 0
                      }}
                    >
                      No deductions components added yet.
                    </motion.p>
                  ) : (
                    <Box sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px"
                    }}>
                      <AnimatePresence>
                        {deductions.map((field, index) => (
                          <motion.div
                            key={index}
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 20 }}
                            transition={{ duration: 0.2 }}
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "12px 16px",
                              background: colors.primary[500],
                              color: colors.grey[100],
                              borderRadius: "6px",
                              border: `1px solid ${colors.primary[600]}`,
                              cursor: "pointer"
                            }}
                            whileHover={{ 
                              backgroundColor: colors.grey[600]
                            }}
                          >
                            <span style={{ 
                              flex: 1,
                              color: colors.grey[100],
                              fontWeight: 500
                            }}>
                              {field}
                            </span>
                            <motion.button
                              whileHover={{ scale: 1.1 }}
                              whileTap={{ scale: 0.9 }}
                              style={{
                                background: colors.redAccent[500],
                                color: colors.grey[100],
                                border: "none",
                                width: "28px",
                                height: "28px",
                                borderRadius: "50%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: 0
                              }}
                              onClick={() => removeField(setDeductions, index)}
                              aria-label={`Remove ${field}`}
                            >
                              ×
                            </motion.button>
                          </motion.div>
                        ))}
                      </AnimatePresence>
                    </Box>
                  )}
                </AnimatePresence>
              </>
            )}
          </Box>

          <motion.button
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={updateCTC}
            disabled={loading}
            style={{
              width: "100%",
              padding: "12px",
              background: colors.blueAccent[500],
              color: colors.grey[100],
              border: "none",
              borderRadius: "6px",
              fontWeight: 500,
              fontSize: "16px",
              cursor: "pointer",
              marginTop: "24px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "8px",
              opacity: loading ? 0.7 : 1
            }}
          >
            {loading ? (
              <>
                <span style={{
                  width: "18px",
                  height: "18px",
                  border: `3px solid ${colors.grey[100]}`,
                  borderRadius: "50%",
                  borderTopColor: "transparent",
                  animation: "spin 1s linear infinite"
                }}></span>
                Updating...
              </>
            ) : (
              "Save CTC Structure"
            )}
          </motion.button>
        </motion.div>
      </Box>

      <style jsx global>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </Box>
  );
};

export default CTCForm;